import { Box, Button, Container, Typography } from "@mui/material";
import { useContext } from "react";
import { LocalizationContext } from "../lib/context";
import { useRouter } from "next/router";

export function DiscountNotFound() {
  const { localeStrings } = useContext(LocalizationContext);
  const router = useRouter();
  return (
    <Container
      className="mt-extra pt-huge mb-huge flex col justify-content-center gap-large"
      sx={{
        position: "relative",
      }}
    >
      <Typography textAlign="center">
        {localeStrings.uiGeneral.discountNotFoundTitle}
      </Typography>
      <Box
        sx={{
          mt: 3,
          display: "flex",
          justifyContent: "center",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <Button variant="contained" onClick={() => router.push("/")}>
          {localeStrings.uiGeneral.goToHomepageButton}
        </Button>
        <Button onClick={() => router.push("/droners")}>
          {localeStrings.uiGeneral.searchDronePilotsButton}
        </Button>
      </Box>
    </Container>
  );
}
